module.exports = __webpack_public_path__ + "img/430c38bc59d16b35542fb2cd2689ac94.svg";